export default "__VITE_ASSET__Bb$Ndb9Z__"